<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">Town Bronze</span></p>
<p class="p0">By Ellie Thomas</p>
<p class="p2"><a id="a4"></a> </p>
<p class="p2"><a href="#/004#a38">Chapter 1</a></p>
<p class="p2"><a href="#/005#a39">Chapter 2</a></p>
<p class="p2"><span href="#/006#a40" title="Link target outside of Sample">Chapter 3</span></p>
<p class="p2"><span href="#/007#a41" title="Link target outside of Sample">Chapter 4</span></p>
<p class="p2"><span href="#/008#a42" title="Link target outside of Sample">Chapter 5</span></p>
<p class="p2"><span href="#/009#a43" title="Link target outside of Sample">Chapter 6</span></p>
<p class="p2"><span href="#/010#a44" title="Link target outside of Sample">Chapter 7</span></p>
<p class="p2"><span href="#/011#a45" title="Link target outside of Sample">Chapter 8</span></p>
<p class="p2"><span href="#/012#a46" title="Link target outside of Sample">Chapter 9</span></p>
<p class="p2"><span href="#/013#a47" title="Link target outside of Sample">Chapter 10</span></p>
<p class="p2"><span href="#/014#a48" title="Link target outside of Sample">Chapter 11</span></p>
<p class="p2"><span href="#/015#a49" title="Link target outside of Sample">Chapter 12</span></p>
<p class="p2"><span href="#/016#a50" title="Link target outside of Sample">Chapter 13</span></p>
<p class="p2"><span href="#/017#a51" title="Link target outside of Sample">Chapter 14</span></p>
<p class="p2"><span href="#/018#a52" title="Link target outside of Sample">Chapter 15</span></p>
<p class="p2"><span href="#/019#a53" title="Link target outside of Sample">Chapter 16</span></p>
<p class="p2"><span href="#/020#a54" title="Link target outside of Sample">Chapter 17</span></p>
<p class="p2"><span href="#/021#a55" title="Link target outside of Sample">Chapter 18</span></p>
<p class="p2"><span href="#/022#a56" title="Link target outside of Sample">Chapter 19</span></p>
<p class="p2"><span href="#/023#a57" title="Link target outside of Sample">Chapter 20</span></p>
<p class="p2"><span href="#/024#a58" title="Link target outside of Sample">Chapter 21</span></p>
<p class="p2"><span href="#/025#a59" title="Link target outside of Sample">Chapter 22</span></p>
<p class="p2"><span href="#/026#a60" title="Link target outside of Sample">Chapter 23</span></p>
<p class="p2"><span href="#/027#a61" title="Link target outside of Sample">Chapter 24</span></p>
<p class="p2"><span href="#/028#a62" title="Link target outside of Sample">Chapter 25</span></p>
<p class="p2"><span href="#/029#a63" title="Link target outside of Sample">Chapter 26</span></p>
<p class="p2"><span href="#/030#a64" title="Link target outside of Sample">Chapter 27</span></p>
<p class="p2"><span href="#/031#a65" title="Link target outside of Sample">Chapter 28</span></p>
<p class="p2"><span href="#/032#a66" title="Link target outside of Sample">Chapter 29</span></p>
<p class="p2"><span href="#/033#a67" title="Link target outside of Sample">Chapter 30</span><a href="#/#a37"></a></p>
<h1 class="h10"><a id="ncx53"></a><a id="a37"></a> </h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?6c5b584a